module.exports = __webpack_public_path__ + "e64969a373d0acf2586d1fd4224abb90.woff2";